import { Component, OnInit, ViewEncapsulation, Input, ViewChild, ElementRef } from '@angular/core';
import { UEditorComponent } from 'ngx-ueditor';
import { SetService } from 'ngx-block-core';
import { FormGroup } from '@angular/forms';
import { FormControlService } from "ngx-block-core";
import { selectSize, iconTheme } from "../../../data/data";
@Component({
    selector: 'app-sucu04-weiget0080002',
    templateUrl: './sucu04-weiget0080002.component.html',
    styleUrls: ['./sucu04-weiget0080002.component.css']
})
export class Sucu04Weiget0080002Component implements OnInit {
    @Input() local = false;
    @Input() static = false;
    @Input() blockid = "-1";
    @Input() layoutid = "-1";
    @Input() form: FormGroup;
    @Input() nzFormGroupData;
    @Input() nzLayout = 'horizontal'
    @Input() acl = 'cy';
    @Input() sets = {
        blockCode: "sucublock48",
        blockId: "",
        blockName: "重富文本",
        layoutId: "",
        blockType: 'formBlock',
        blockChildType: '',
        versionCode: 3,
        attributes: ['form', 'nzFormGroupData', 'nzLayout'],
        sets: {
            acl: false
        },
        styles: {
            nzLayout: {
                nzLayout1: 0,
                nzLayout2: 24,
                nzLayout3: 0,
                nzLayout4: 24,
                nzAlign: 'left',
                nzMarginBottom: 3,
                nzLineHeight: 1.4,
                nzFontSize: 12
            },
            nzRequired: false,
            nzHasFeedback: true,
            nzReadOnly: false,
        },
        datas: {
            nzSearchDataType: "string|array",
            nzSearchType: "like",
        }
    };
    @ViewChild('full') full: UEditorComponent;
    setData = []

    constructor(
        private el: ElementRef,
        public setService: SetService,
        public formControlService: FormControlService
    ) { }
    getAllHtml() {
        // 通过 `this.full.Instance` 访问ueditor实例对象
        alert(this.full.Instance.getAllHtml())
    }
    ngOnInit() {
        this.baseInit();
        this.autoUpdate();
    }
    autoUpdate() {

        //v3,升级自定义表单参数
        if (this.sets.versionCode < 3) {

            this.sets.blockCode = "sucublock48";

            this.sets.versionCode = 3;
        }

    }
    setDataInit() {
        this.setData = [
            {
                tabName: '数据',
                datas: [
                    {
                        type: 'datas',
                        data: [
                            { name: 'nzFormDataSource' },
                        ]
                    }
                ]
            },
            {
                tabName: '样式',
                datas: [
                    {
                        type: 'styles',
                        data: [
                            {
                                name: 'input',
                                inputs: { nzText: "积木名称 : ", nzKeys: ['blockName'] }
                            },
                            {
                                name: 'switch',
                                inputs: { nzText: "只读 : ", nzKeys: ['styles', 'nzReadOnly'] }
                            }
                        ]
                    },
                ]
            },
            {
                tabName: '表单',
                datas: [
                    {
                        type: 'datas',
                        data: [
                            { name: 'nzFormSet' },
                        ]
                    }
                ]
            }

        ]
    }
    baseInit() {

        if (!this.local) {//非本地
            if (!this.static) {//非静态
                if (this.setService.blocksort[this.blockid]['sets'] !== "{}") {
                    this.sets = this.setService.blocksort[this.blockid]['sets'];
                } else {
                    this.setService.blocksort[this.blockid]['sets'] = this.sets;
                }
                this.sets.blockId = this.blockid;
                this.sets.layoutId = this.layoutid;
                this.nzFormGroupData['nzSearchDataType'] = "string|array";
                if (this.nzFormGroupData['nzSearchType'] == 'null')
                    this.nzFormGroupData['nzSearchType'] = "like";
                this.setDataInit();
                if (typeof this.setService.setDatas[this.blockid] == 'undefined') {
                    this.setService.setDatas[this.blockid] = this.setData;
                }
               
                this.pzListening()
            }
            else {//静态
                if(typeof this.sets=="string")
        this.sets = JSON.parse(<any>this.sets);
                this.blockid = this.sets.blockId;
                this.layoutid = this.sets.layoutId;
            }
        }
    }
    pzListening() {
        setTimeout(() => {
            this.setService.initEvent(this.blockid, 'pz');
            this.setService.pzEvents[this.blockid].subscribe(data => {
                switch (data['type']) {
                    case 'changeFormValid':
                        this.formControlService.setValidators(this.form, this.nzFormGroupData.nzKey, this.nzFormGroupData);
                        break;

                    default:
                        break;
                }
            }
            )
        }, 100);

    }
    ngOnDestroy() {
        if (!this.static) this.setService.deleteEvent(this.blockid, 'pz')
    }
}
